var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-app"},[_c('router-view',{staticClass:"v-router"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }